export default __webpack_public_path__ + "static/media/bullet-green.decd32d6.svg";